module.exports = __webpack_public_path__ + "img/banking-details.b3820207.svg";